var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57339 11.9999C6.48198 11.9996 6.39161 11.9806 6.30788 11.9439C6.22416 11.9072 6.14888 11.8536 6.08672 11.7866L2.84672 8.33994C2.72561 8.21087 2.66073 8.03897 2.66635 7.86206C2.67198 7.68515 2.74765 7.51772 2.87672 7.39661C3.0058 7.27549 3.17769 7.21061 3.3546 7.21624C3.53151 7.22186 3.69894 7.29753 3.82006 7.42661L6.56672 10.3533L12.1734 4.21994C12.2303 4.14909 12.3011 4.09062 12.3814 4.04812C12.4617 4.00562 12.5499 3.97998 12.6404 3.97279C12.731 3.9656 12.8221 3.97701 12.9081 4.00631C12.9942 4.03561 13.0733 4.08218 13.1406 4.14317C13.208 4.20416 13.2622 4.27828 13.2999 4.36097C13.3375 4.44366 13.3579 4.53318 13.3597 4.62403C13.3615 4.71488 13.3448 4.80515 13.3104 4.88928C13.2761 4.97341 13.2249 5.04964 13.1601 5.11327L7.06672 11.7799C7.00515 11.8482 6.93013 11.9029 6.84638 11.9408C6.76263 11.9787 6.67196 11.9988 6.58006 11.9999H6.57339Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkLight);
export default __webpack_public_path__ + "static/media/checkmark_light.2b5452b0.svg";
export { ForwardRef as ReactComponent };